import { IMenuModel } from "src/model"
import { BasicLayout} from "src/components/layouts/layout"
import user from "src/views/system/user/index.vue";
import role from "src/views/system/role/index.vue";
import app from "src/views/system/app/index.vue";
import org from "src/views/system/org/index.vue";
import pos from "src/views/system/pos/index.vue";

/**
 * 表示菜单数据模型
 */
interface IMenuNav{
    pid?: number, // 父id
    children?: Array<IMenuNav>, // 子级菜单
    component: string, // 组件名称
    key: string // 
    meta:IMenuMeta,
    name: string,
    path: string, // 跳转路径
    redirect: string, // 重定向地址
}

/**
 * 表示菜单扩展数据模型
 */
 interface IMenuMeta{
    icon?: string, // 菜单图标
    link?: string, // 内部链接
    show?: boolean, // 是否显示菜单
    target?: string, // 外部链接
    title?: string,// 菜单名称
}

// 前端路由表
const constantRouterComponents =
{
    BasicLayout: BasicLayout,
    // '403': () => import('@/views/system/exception/403'),
    // '404': () => import('@/views/system/exception/404'),
    // '500': () => import('@/views/system/exception/500'),
}

// 根级菜单
const rootRouter: any = {
    key: '',
    name: 'MenuIndex.vue',
    path: '',
    component: "BasicLayout",
    redirect: '/shop',
    meta: {
      title: '首页'
    },
    children: [
    ]
  }

  // 前端未找到页面路由（固定不用改）、原来为 /404
const notFoundRouter = {
    // path: '*', redirect: '/welcome', hidden: true, compoment: login
  }

// 个人中心页面
const userAccount: Array<IMenuModel> =
[
    // account
    {
        'name': 'account',
        'pid': 0,
        'id': 10028,
        'meta': {
        'title': '个人页',
        'icon': 'user',
        'show': false
        },
        'redirect': 'account/center',
        'component': 'welcome'
    },
    {
        'name': 'center',
        'pid': 10028,
        'id': 10029,
        'meta': {
        'title': '个人中心',
        'show': false
        },
        'component': 'welcome'
    }
]

/**
 * 动态生成菜单
 * @param data
 * @returns {Promise<Router>}
 */
export const generatorDynamicRouter = (data: Array<IMenuModel>) =>
{
    return new Promise((resolve, reject) =>
    {
        const menuNav = []
        // 最终子菜单
        const childrenNav: Array<any> = [];

        // 增加后台返回动态菜单
        // 后端数据, 根级树数组,  根级 PID
        data && data.length > 0 && listToTree(data, childrenNav, 0)

        // 增加静态网页
        listToTree(userAccount, childrenNav, 0)
        // rootRouter.children.push(...childrenNav);
        rootRouter.children =childrenNav;
        menuNav.push(rootRouter)
        const routers = generator(menuNav)
        // routers.push(notFoundRouter)
        resolve(routers)
    }).catch(err => {
        return Promise.reject(err)
    })
}

/**
 * 数组转树形结构
 * @param list 源数组
 * @param tree 树
 * @param parentId 父ID
 */
const listToTree = (list: Array<IMenuModel>, tree: Array<any>, parentId: number) => {
    list.forEach(item => {
        // 判断是否为父级菜单
        if (item.pid == parentId) {
            const child: any = {
                ...item,
                key: item.key || item.name,
                children: []
            }
            // 迭代 list， 找到当前菜单相符合的所有子菜单
            listToTree(list, child.children, item.id)
            // 删掉不存在 children 值的属性
            if (child.children.length === 0)
            {
                delete child.children
            }
            // 加入到树中
            tree.push(child)
        }
    })
}


/**
 * 格式化树形结构数据 生成 vue-router 层级路由表
 * 渲染规则
 * @param routerMap
 * @param parent
 * @returns {*}
 */
export const generator = (routerMap: Array<any>, parent: any = {}) =>
{
    return routerMap.map((item,index) => {
        const { title, show, target, icon, link } = item.meta || {}
        let hideChildrenInMenu = false;
        //  如果子菜单全部不显示，则菜单用item显示，否则SubMenu
       
        if(item.children && item.children)
        {
            hideChildrenInMenu = item.children.every(childrenItem=>{
                return !childrenItem.meta.show
            })
        }
        
        const currentRouter: any =
        {
            // 如果路由设置了 path，则作为默认 path，否则 路由地址 动态拼接生成如 /dashboard/workplace
            path: item.path || `${parent && parent.path || ''}/${item.key}`,
            // 路由名称，建议唯一
            name: item.name || item.key || '',
            // 该路由对应页面的 组件 :方案1
            // component: constantRouterComponents[item.component || item.key],
            // 该路由对应页面的 组件 :方案2 (动态加载)
            component: (constantRouterComponents[item.component || item.key]) || (() => import(`@/views/${item.component}`)),
            // meta: 页面标题, 菜单图标, 页面权限(供指令权限用，可去掉)
            hidden: !show,
            hideChildrenInMenu: hideChildrenInMenu, // 是否隐藏子级菜单 到时需要特殊化处理
            redirect: item.redirect,
            children: null,
            meta:
            {
                title: title,
                icon: icon || undefined,
                hiddenHeaderContent: false, // 是否需要隐藏头部处理(暂留，有需要时再处理)
                target: target,
                link: link
            }
        }
        
        // 是否有子菜单，并递归处理
        if (item.children && item.children.length > 0) {
            currentRouter.children = generator(item.children, currentRouter)
        }

        return currentRouter
    })
}